module.exports = __webpack_public_path__ + "static/media/acacia mall shot 04.ca8354dc.webp";